import { Injectable } from '@angular/core';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { ValidatedResponse } from '@max/shared/models/validated-response.model';
import { map, Observable } from 'rxjs';
import { ImageProcessingResultSearchCriteria } from '../../driver/models/customer/image-processing-result-search-criteria.model';
import { ImageProcessingResultSearchResults } from '../../driver/models/customer/image-processing-result-search-results.model';
import { ImageProcessingResult } from '../../driver/models/customer/image-processing-result.model';
import { ProcessDriverImageRequest } from '../../driver/models/process-driver-image-request.model';
import { ProcessedDriverImageResult } from '../../driver/models/processed-driver-image-result.model';

@Injectable()
export class CustomerImageProcessingService extends BaseApiService {
    constructor() {
        super();
    }
    public processDriverImage(imageRequest: ProcessDriverImageRequest): Observable<ValidatedResponse<ProcessedDriverImageResult>> {
        return this.post('Customer/ImageProcessing/ProcessDriverImage', imageRequest);
    }

    public getImageProcessingResult(driverImageProcessingResultId: number): Observable<ValidatedResponse<ImageProcessingResult>> {
        return this.get(`Customer/ImageProcessing/ImageProcessingResult/${driverImageProcessingResultId}`);
    }

    public searchImageProcessingResults(searchCriteria: ImageProcessingResultSearchCriteria): Observable<ImageProcessingResultSearchResults> {
        return this.post('Customer/ImageProcessing/SearchImageProcessingResults', searchCriteria).pipe(map(r => r.result));
    }
}
